export default "__VITE_ASSET__4faba9fa__"